import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "maxlength", "name", "disabled", "readonly", "value", "placeholder", "autocomplete", "inputmode"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'input-wrapper',
            'input-wrapper--field',
            'input-wrapper--' + _ctx.type,
            'input-wrapper--' + _ctx.name,
        ]),
    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("label", {
      class: _normalizeClass([
                _ctx.error ? 'has-error' : '',
                _ctx.labelShowsValid && _ctx.isValid ? 'valid' : '',
                _ctx.checkIsTaxOfficeField() ? 'valid' : '',
            ])
    }, [
      _createElementVNode("input", {
        type: _ctx.type,
        maxlength: _ctx.maxLength,
        name: _ctx.name,
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        value: _ctx.model ?? '',
        placeholder: _ctx.placeholder,
        autocomplete: _ctx.suggestions ? 'on' : 'nope',
        inputmode: _ctx.isNumeric ? 'decimal' : 'text',
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.focusEvent && _ctx.focusEvent(...args))),
        onPaste: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pasteHandler && _ctx.pasteHandler(...args))),
        onKeypress: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.filterInput && _ctx.filterInput(...args)))
      }, null, 40, _hoisted_1),
      _createElementVNode("div", {
        class: _normalizeClass([
                    _ctx.model?.length ? 'not-empty' : '',
                    'input__label',
                    'input__label--' + _ctx.name,
                    'input__label--' + _ctx.type,
                ])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ], 2),
    (_ctx.handlesError)
      ? (_openBlock(), _createBlock(_component_Error, {
          key: 0,
          name: _ctx.name,
          "value-field": _ctx.model
        }, null, 8, ["name", "value-field"]))
      : _createCommentVNode("", true)
  ], 2))
}